import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
    value: _ctx.computedValue,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedValue) = $event)),
    onSubmit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit')))
  }, null, 40, ["value"]))
}